import { render, staticRenderFns } from "./collapse.vue?vue&type=template&id=a5d9d6a0&scoped=true"
import script from "./collapse.vue?vue&type=script&lang=js"
export * from "./collapse.vue?vue&type=script&lang=js"
import style0 from "./collapse.vue?vue&type=style&index=0&id=a5d9d6a0&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d9d6a0",
  null
  
)

export default component.exports